export function iterateObserversSafely(observers, method, argument) {
    var observersWithMethod = [];
    observers.forEach(function (obs) { return obs[method] && observersWithMethod.push(obs); });
    observersWithMethod.forEach(function (obs) { return obs[method](argument); });
}
//# sourceMappingURL=iteration.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@apollo/client/utilities/observables/iteration.js
// module id = 148
// module chunks = 17